import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ProfessionalForm from './ProfessionalForm/ProfessionalForm';
import Footer from './Footer/Footer';
import Courses from './Courses/Courses';
import Navbar from './Navbar/Navbar';
import SupportSection from './SupportSection/SupportSection';
import CourseSection from './CourseSection/CourseSection';
import FAQ from './FAQ/FAQ';
import Admissions from './Contact/Admissions';
import ScrollAnimation from './ScrollAnimations/ScrollAnimation';

import IndustryProjects from './ToolSection/IndustryProjects';
import InterviewPrep from './InterviewPrep/InterviewPrep';
import CertificateSection from './CertificateSection/CertificateSection';

import About from './Pages/About';
import Reviews from './Pages/Reviews';
import Careers from './Pages/Careers';
import Blog from './Pages/Blog';
import BlogDetails from './Pages/BlogDetails';
import Internships from './Pages/Internships';
import Placements from './Pages/Placements';
import Contact from './Pages/Contact';
import CoursesPage from './Pages/CoursesPage';
import IndustryConnect from './IndustryConnect/IndustryConnect';
import StudentExperience from './StudentExperience/StudentExperience';
import Testimonials from './Testimonials/Testimonials';
import HiringCompanies from './HiringCompanies/HiringCompanies';


/* =========================================
   HOME PAGE
========================================= */

function Home() {
  return (
    <div className="App">

      {/* =========================================
          HERO / PROFESSIONAL FORM
      ========================================= */}

      <div id="form">
        <ScrollAnimation animation="fade-up">
          <ProfessionalForm />
        </ScrollAnimation>
      </div>


      {/* =========================================
          WHY PRT ACADEMY
      ========================================= */}

      <div id="why-prt">
        <ScrollAnimation animation="fade-right">
          <SupportSection />
        </ScrollAnimation>
      </div>


      {/* =========================================
          COURSES
      ========================================= */}

      <div id="courses">
        <ScrollAnimation animation="fade-right">
          <Courses />
        </ScrollAnimation>
      </div>


      {/* =========================================
          5-STEP CAREER PATHWAY
      ========================================= */}

      <div id="career-pathway">
        <ScrollAnimation animation="fade-left">
          <CourseSection />
        </ScrollAnimation>
      </div>


      {/* =========================================
          REAL PROJECTS + INDUSTRY TOOLS
      ========================================= */}

      <div id="industry-projects">
        <ScrollAnimation animation="fade-up">
          <IndustryProjects />
        </ScrollAnimation>
      </div>


      {/* =========================================
          INTERVIEW PREP & COMMUNICATION
      ========================================= */}

      <div id="interview-prep">
        <ScrollAnimation animation="fade-up">
          <InterviewPrep />
        </ScrollAnimation>
      </div>

      {/* =========================================
    INDUSTRY CONNECT
========================================= */}

<div id="industry-connect">
  <ScrollAnimation animation="fade-up">
    <IndustryConnect />
  </ScrollAnimation>
</div>


      {/* =========================================
          CERTIFICATION
      ========================================= */}

      <div id="certification">
        <ScrollAnimation animation="fade-up">
          <CertificateSection />
        </ScrollAnimation>
      </div>

<div id="student-experience">
  <ScrollAnimation animation="fade-up">
    <StudentExperience />
  </ScrollAnimation>
</div>
<div id="testimonials">
  <ScrollAnimation animation="fade-up">
    <Testimonials />
  </ScrollAnimation>
</div>

<div id="hiring-companies">
  <HiringCompanies />
</div>



      {/* =========================================
          ADMISSIONS / CONTACT
      ========================================= */}

      <div id="admissions">
        <ScrollAnimation animation="fade-left">
          <Admissions />
        </ScrollAnimation>
      </div>


      {/* =========================================
          FAQ
      ========================================= */}

      <div id="faq">
        <ScrollAnimation animation="fade-up">
          <FAQ />
        </ScrollAnimation>
      </div>

    </div>
  );
}


/* =========================================
   APP / ROUTES
========================================= */

function App() {
  return (
    <BrowserRouter>

      <div className="App">

        <Navbar />

        <Routes>

          {/* HOME */}
          <Route path="/" element={<Home />} />

          {/* PAGES */}
          <Route path="/about" element={<About />} />

          <Route path="/reviews" element={<Reviews />} />

          <Route path="/careers" element={<Careers />} />

          <Route path="/blog" element={<Blog />} />

          <Route path="/blog/:slug" element={<BlogDetails />} />

          <Route path="/internships" element={<Internships />} />

          <Route path="/placements" element={<Placements />} />

          <Route path="/contact" element={<Contact />} />

          <Route path="/courses" element={<CoursesPage />} />

        </Routes>

        <Footer />

      </div>

    </BrowserRouter>
  );
}

export default App;